// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operation_operation__yC\\+bO {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  z-index: 10;
  width: 240px; }

.operation_name__X-7Ey {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #666666; }

.operation_video__9K7Jj {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #fe6100;
  cursor: pointer;
  transition: all 0.4s; }
  .operation_video__9K7Jj:hover {
    color: #E55700; }

.operation_respTime__K9pP5 {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #666666; }

.operation_noVideo__qFgDu, .operation_loading__AjGI0, .operation_link__OhpvT {
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: #9e9e9e; }

.operation_link__OhpvT {
  color: #FE6100;
  text-decoration: none;
  transition: all 0.3s; }
  .operation_link__OhpvT:hover {
    border-bottom: 1px solid #FE6100;
    border-bottom-color: #FE6100; }

.operation_status__kcU7H {
  position: absolute;
  bottom: 9px;
  right: 9px; }
`, "",{"version":3,"sources":["webpack://./src/pages/OrdersViewD3/components/operation.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc,EAAA;;AAGhB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB,EAAA;EAXtB;IAaI,cAAa,EAAA;;AAIjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB,EAAA;EAHtB;IAKI,gCAAgC;IAChC,4BAA4B,EAAA;;AAIhC;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA","sourcesContent":[".operation {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding: 5px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  z-index: 10;\n  width: 240px;\n}\n\n.name {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.1px;\n  color: #666666;\n}\n\n.video {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.1px;\n  color: #fe6100;\n  cursor: pointer;\n  transition: all 0.4s;\n  &:hover{\n    color:#E55700;\n  }\n}\n\n.respTime {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.1px;\n  color: #666666;\n}\n\n.noVideo, .loading,.link {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 150%;\n  color: #9e9e9e;\n}\n\n.link{\n  color: #FE6100;\n  text-decoration: none;\n  transition: all 0.3s;\n  &:hover {\n    border-bottom: 1px solid #FE6100;\n    border-bottom-color: #FE6100;\n  }\n}\n\n.status{\n  position: absolute;\n  bottom: 9px;\n  right: 9px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"operation": `operation_operation__yC+bO`,
	"name": `operation_name__X-7Ey`,
	"video": `operation_video__9K7Jj`,
	"respTime": `operation_respTime__K9pP5`,
	"noVideo": `operation_noVideo__qFgDu`,
	"loading": `operation_loading__AjGI0`,
	"link": `operation_link__OhpvT`,
	"status": `operation_status__kcU7H`
};
export default ___CSS_LOADER_EXPORT___;
